import { render, staticRenderFns } from "./BadgeNum.vue?vue&type=template&id=137a64ef&scoped=true&"
import script from "./BadgeNum.vue?vue&type=script&lang=js&"
export * from "./BadgeNum.vue?vue&type=script&lang=js&"
import style0 from "./BadgeNum.vue?vue&type=style&index=0&id=137a64ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137a64ef",
  null
  
)

export default component.exports